import { IMongoDocument } from "@/types"

export const EFFECT_TYPES = {
  DIG_THROUGH_BLOCK: "dig_through_block",
  FREEZING: "freezing",
  RUNE_STATE: "rune_state",
  RUNE_MIMING_DELTA: "rune_miming_delta",
  STEAL_RUNES_STATE: "steal_runes_state",
  INC_DIG_DISTANCE: "inc_dig_distance",
  INC_BLOCK_DISTANCE: "inc_block_distance",
  SPEED_BONUS: "speed_bonus",
  STEAL_OPPONENTS_DIGGING: "steal_opponents_digging",
  SKIP_DIG: "skip_dig",
  AUTO_DIG: "auto_dig",
  DISCHARGE: "discharge"
} as const
export type IEffectType = (typeof EFFECT_TYPES)[keyof typeof EFFECT_TYPES]

export const EFFECT_DIGGING_TYPES = new Set<IEffectType>([
  EFFECT_TYPES.DIG_THROUGH_BLOCK,
  EFFECT_TYPES.INC_DIG_DISTANCE,
  EFFECT_TYPES.AUTO_DIG
])

export enum EffectTarget {
  NONE = "none", // no specific target
  SELF = "self", // the player who played the card
  OPPONENT = "opponent", // the opposing player
  BOTH = "both" // applies to both players
}

export interface IEffect extends IMongoDocument {
  description: string
  durationMovements: number
  playerTarget: string
  probabilityPercentage: number
  runeTarget: string
  type: IEffectType
  value: number
}

export interface IActiveEffect extends IMongoDocument {
  effect: IEffect
  sessionId: string
  usedCardImgSrc: string
  activatedByPlayer: string
  targetPlayer: string
  remainingMovements: number
}
